import * as yup from 'yup';

export default function getValidatedParams({
  params,
  schema,
}: {
  readonly params: any;
  readonly schema: any;
}) {
  try {
    return yup
      .object(schema)
      .noUnknown(true)
      .validateSync(params, { abortEarly: false, stripUnknown: true });
  } catch (error) {
    if (error instanceof yup.ValidationError) {
      const invalidPaths = new Set(error.inner.map((err) => err.path).filter(Boolean));

      return Object.entries(params).reduce((acc, [k, v]) => {
        if (!invalidPaths.has(k)) {
          Object.assign(acc, { [k]: v });
        }
        return acc;
      }, {});
    }

    return {};
  }
}
